// CSS order matters. AdminLTE (which contains Bootstrap 5.3) loads first, before any module
// below pulls in a component stylesheet, so those still override Bootstrap. The ErpBoi theme
// loads last so it wins.
import "admin-lte/dist/css/adminlte.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "@fontsource/source-sans-3/400.css";
import "@fontsource/source-sans-3/600.css";
import "@fontsource/source-sans-3/700.css";
import { AuthProvider } from '@context/Auth';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import React from 'react';
import { createRoot } from "react-dom/client";
import { ToastContainer } from 'react-toastify';
import App from "./App";
import "./assets/css/erpboi-theme.scss";
import reportWebVitals from "./reportWebVitals";


const queryClient = new QueryClient();

const container = document.getElementById("root") as HTMLElement;

createRoot(container).render(
	<React.StrictMode>
		<QueryClientProvider client={queryClient}>
			<AuthProvider>
				<App />
			</AuthProvider>
			<ToastContainer />
		</QueryClientProvider>
	</React.StrictMode>
);

reportWebVitals();
